import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ZeszytOnlineModule } from '@enauka/strona-glowna';

const routes: Routes = [
  {
    path: '', loadChildren: () => ZeszytOnlineModule,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, initialNavigation: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
